export const selectBootstrapLoading = (state) => state?.bootstrap?.isLoading;
export const selectBootstrapError = (state) => state?.bootstrap?.errors;
export const selectCurrUser = (state) => state?.bootstrap?.currUser;
export const selectSettings = (state) => {
  return state?.bootstrap?.settings;
};
export const selectCurrUserPermission = (state) =>
  state?.bootstrap?.permissions;
export const selectUser = (state) => state?.bootstrap?.user;
export const selectExtensionInstallStatus = (state) =>
  state?.bootstrap?.extensionInstalled;

export const selectContactImport = (state) => state?.bootstrap?.contactImport;
export const selectContactImportById = (state) =>
  state?.bootstrap?.contactImportById;

export const selectPermissionLoading = (state) =>
  state?.bootstrap?.permissionLoading;
